import { Check } from "lucide-react";

export const QuestionStep = ({ q, value, onChange, children }) => (
  <div>
    <h3 data-testid="quiz-question-title" className="font-display text-[22px] font-bold leading-tight tracking-tight text-[#0B1B33] md:text-[26px]">{q.title}</h3>
    <p className="mt-2 text-[14px] text-slate-600">{q.hint}</p>
    <div className="mt-5 grid gap-2">
      {q.options.map((o, i) => {
        const on = value === o;
        return (
          <button key={o} data-testid={`quiz-option-${q.key}-${i}`} onClick={() => onChange(o)}
            className={`group flex items-center gap-3 rounded-xl border px-4 py-3 text-left text-[15px] transition-[border-color,background-color,transform] duration-200 hover:-translate-y-0.5 ${on ? "border-[#0E9384] bg-teal-50/70 text-[#0B1B33]" : "border-slate-200 text-slate-800 hover:border-slate-400"}`}>
            <span className={`grid h-5 w-5 shrink-0 place-items-center rounded-full border-2 transition-colors ${on ? "border-[#0E9384] bg-[#0E9384] text-white" : "border-slate-300"}`}>
              {on && <Check className="h-3 w-3" strokeWidth={3.5} />}
            </span>
            {o}
          </button>
        );
      })}
    </div>
    {children}
  </div>
);
